import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import CountdownTimer from "@/components/CountdownTimer";

const CHECKOUT_URL = "https://payhip.com/order?link=8mes1&pricing_plan=YLBN5OxvzK";

export default function StickyBar() {
  const [showDesktop, setShowDesktop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowDesktop(window.scrollY > window.innerHeight * 0.75);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* Desktop sticky bar */}
      <AnimatePresence>
        {showDesktop && (
          <motion.div
            key="desktop-bar"
            initial={{ y: -64, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -64, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            className="hidden md:flex fixed left-0 right-0 z-40 px-8 py-3 items-center justify-between"
            style={{
              top: "60px",
              background: "rgba(10,10,10,0.92)",
              backdropFilter: "blur(20px)",
              borderBottom: "1px solid rgba(255,255,255,0.06)",
            }}
            data-testid="sticky-bar-desktop"
          >
            <CountdownTimer compact />
            <div className="flex items-center gap-2">
              <span className="text-[#86868b] line-through text-sm">499€</span>
              <span className="text-[#C9A84C] font-black text-xl">299€</span>
            </div>
            <a
              href={CHECKOUT_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="sticky-bar-cta"
              className="bg-[#C9A84C] text-[#0A0A0A] font-black px-6 py-2 rounded-full hover:bg-[#E0C375] transition-colors duration-200 text-sm"
            >
              Jetzt sichern →
            </a>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Mobile sticky bar */}
      <div
        className="flex md:hidden fixed bottom-0 left-0 right-0 z-40 px-5 py-4 items-center justify-between"
        style={{
          background: "rgba(10,10,10,0.96)",
          backdropFilter: "blur(20px)",
          borderTop: "1px solid rgba(255,255,255,0.08)",
        }}
        data-testid="sticky-bar-mobile"
      >
        <div className="flex flex-col leading-none">
          <span className="text-[#86868b] line-through text-xs">499€</span>
          <span className="text-[#C9A84C] font-black text-2xl" style={{ textShadow: "0 0 12px rgba(201,168,76,0.3)" }}>
            299€
          </span>
        </div>
        <a
          href={CHECKOUT_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-bar-mobile-cta"
          className="bg-[#C9A84C] text-[#0A0A0A] font-black px-7 py-3 rounded-full hover:bg-[#E0C375] transition-colors duration-200 text-sm"
        >
          Jetzt für 299€ →
        </a>
      </div>
    </>
  );
}
